var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataStudio = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.545 10.12a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm6.788 0a1.213 1.213 0 1 1 0 2.426 1.213 1.213 0 0 1 0-2.425zM7.939 6.728a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zM4.545 3.333a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm6.788 0a1.212 1.212 0 1 1 0 2.425 1.212 1.212 0 0 1 0-2.425z",
  fill: "#1871BF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 13.576A1.212 1.212 0 1 1 8 16a1.212 1.212 0 0 1 0-2.424zm0-3.394a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zM1.212 6.788a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm3.394 0a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm6.789 0a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm3.393 0a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zM8 3.394a1.213 1.213 0 1 1-.002 2.425A1.213 1.213 0 0 1 8 3.394zM8 0a1.212 1.212 0 1 1 0 2.424A1.212 1.212 0 0 1 8 0z",
  fill: "#A7CEEF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataStudio);
export default ForwardRef;